// TODO: Handle if you move across screens?
export function pixelRatio(): number {
  return devicePixelRatio || 1;
}
